import {Injectable} from '@angular/core';
import {HttpHelperService} from "./http-helper.service";
import {BehaviorSubject, Subject} from "rxjs";
import {NotificationMessage} from "./models/notifications/NotificationMessage";
import {NotificationCheckResult} from "./models/notifications/NotificationCheckResult";
import {DeliveredNotifications, PushNotifications} from "@capacitor/push-notifications";

@Injectable()
export class NotificationService {
  evShowNotification: Subject<NotificationMessage[]> = new Subject<NotificationMessage[]>();
  evPermissionStatusChanged: BehaviorSubject<PushPermissions> = new BehaviorSubject<PushPermissions>(PushPermissions.notInitialized);
  permStatus: PushPermissions = PushPermissions.notInitialized;
  constructor(private httpHelper: HttpHelperService) {
    // console.log('NotificationService: created');
  }
  checkForBanners() {
    this.httpHelper.get<NotificationCheckResult>('notification').then(apiResult => {
      if (apiResult.statusId === 200 && apiResult.resultData != null && apiResult.resultData.length > 0) {
        this.evShowNotification.next(apiResult.resultData);
      }
    });
  }
  async checkPushPermissions() : Promise<PushPermissions> {
    // console.log('checking push permission');
    let permStatus = await PushNotifications.checkPermissions();
    this.permStatus =  this.parsePushPermissions(permStatus.receive);
    if (this.evPermissionStatusChanged.getValue() !== this.permStatus) {
      // console.log('sc: checkPushPermissions');
      if (this.permStatus === PushPermissions.granted) {
        await this.registerForNotifications();
      }
      this.evPermissionStatusChanged.next(this.permStatus);
    }
    return this.permStatus;
  }
  async requestPermission() : Promise<PushPermissions> {
    // console.log('requesting push permission');
    const permStatus = await PushNotifications.requestPermissions();
    // console.log(`permission request result: ${permStatus.receive}`);
    this.permStatus =  this.parsePushPermissions(permStatus.receive);
    if (this.evPermissionStatusChanged.getValue() !== this.permStatus) {
      // console.log('sc: requestPermission');
      if (this.permStatus === PushPermissions.granted) {
        await this.registerForNotifications();
      }
      this.evPermissionStatusChanged.next(this.permStatus);
    }
    return this.permStatus;
  }
  async registerForNotifications() {
    // console.log('registering for notifications');
    await PushNotifications.register();
    // console.log('registering for notifications -> registered');
  }
  async unregister() {
    // console.log('unregistering notifications');
    return PushNotifications.unregister();
  }
  async getDeliveredNotifications() : Promise<DeliveredNotifications> {
    return await PushNotifications.getDeliveredNotifications();
  }
  async removeAllDeliveredNotifications() {
    await PushNotifications.removeAllDeliveredNotifications();
  }
  private parsePushPermissions(value: string): PushPermissions {
    // console.log(`parsing push permissions: ${value}`);
    switch (value) {
      case "denied":
        return  PushPermissions.denied;
      case "granted":
        return  PushPermissions.granted;
      case "prompt":
        return  PushPermissions.prompt;
      case "prompt-with-rationale":
        return PushPermissions.promptWithRationale;
      default:
        return PushPermissions.notInitialized;
    }
  }

}
export enum PushPermissions {
  notInitialized = 0,
  denied = 1,
  granted = 2,
  prompt = 3,
  promptWithRationale = 4
}
